import React from 'react';
import './Header.css';
import logo from '../assets/images/LOGO VERTICAL.png'; // Importando o logo

const Header = () => {
    return (
        <header className="header">
            <div className="header-brand">
                <img src={logo} alt="Logo Prefeitura" className="header-logo" />
                <h1 className="header-title">Portal de Sistemas</h1>
            </div>
            <nav className="header-nav">
                <ul>
                    <li><a href="/semgi/login">Protocolo</a></li>
                    <li><a href="/processo-administrativo">Processo Administrativo</a></li>
                    <li><a href="/patrimonio">Patrimônio</a></li>
                    <li><a href="/secretarias">Secretarias</a></li>
                    <li><a href="http://gestaodacidade.com.br:3004/legislacao">Legislação</a></li>
                    <li><a href="http://gestaodacidade.com.br:3004/login">Servidores</a></li>
                    <li><a href="http://192.168.128.251:3004/">Servidores (interno)</a></li>
                </ul>
            </nav>
        </header>
    );
};

export default Header;